if (typeof SliderComponent !== 'undefined') {
  class FortVisitsGallery extends SliderComponent {
    constructor() {
      super();

      if (!this.slider) return;

      this.sliderControlLinksArray = Array.from(this.querySelectorAll('.slider-counter__link'));
      if (!this.sliderControlLinksArray.length) return;

      this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    }

    linkToSlide(event) {
      event.preventDefault();
      if (!this.sliderItemOffset) return;

      const slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderItemOffset * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
      this.slider.scrollTo({ left: slideScrollPosition });
    }

    update() {
      super.update();
      if (!this.sliderControlLinksArray || !this.sliderControlLinksArray.length) return;

      this.sliderControlLinksArray.forEach((link) => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });

      const activeLink = this.sliderControlLinksArray[this.currentPage - 1];
      if (activeLink) {
        activeLink.classList.add('slider-counter__link--active');
        activeLink.setAttribute('aria-current', 'true');
      }
    }
  }

  customElements.define('fort-visits-gallery', FortVisitsGallery);
}
